<template>
  <div id="app">
    <h1>Teste de carga de video</h1>
    <VideoJSRecord />

    <div class="block_movie" v-for="video in videos" :key="video.id">
      <VideoPlayer
        :options="{
      autoplay: false,
      responsive: true,
      controls: true,
      sources: [
      {
      src: video.video_path,
      type: 'video/mp4'
      }
      ]
      }"
      />
    </div>

    <VideoPlayer
      :options="{
      autoplay: false,
      responsive: true,
      controls: true,
      sources: [
      {
      src: '/a.mp4',
      type: 'video/mp4'
      }
      ]
      }"
    />
  </div>
</template>

<script>
import VideoJSRecord from "components/VideoJSRecord.vue";
import VideoPlayer from "components/VideoPlayer.vue";
import axios from "axios";
export default {
  name: "app",
  components: {
    VideoJSRecord,
    VideoPlayer
  },
  data() {
    return {
      videos: []
    };
  },
  mounted() {
    let movies = [];

    axios.get("/movies").then(response => {
      this.videos = response.data.movies;
    });
  }
};
</script>

<style>
/* change player background color */
#myVideo {
  background-color: #95ddf5;
}
</style>